import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import useHasPermission from 'app/hooks/useHasPermission'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useTabsByPermission from 'app/hooks/useTabsByPermission/useTabsByPermission'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import tableConfig from './FreightForwarders.config'
import FreightForwarderCreate from './FreightForwarderCreate'
import FreightForwarderOverview from './FreightForwarderOverview'
import FreightForwarderUpdate from './FreightForwarderUpdate'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const FreightForwarders = () => {
    const createPermission = useHasPermission(['freight_forwarder_create'])
    const updatePermission = useHasPermission(['freight_forwarder_update'])
    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: 'Overview',
                url: CommonRoutes.Overview,
                Component: FreightForwarderOverview,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Data Update',
                url: CommonRoutes.DataUpdate,
                Component: FreightForwarderUpdate,
            },
            permission: updatePermission,
        },
    ])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: createPermission
                    ? FreightForwarderCreate
                    : undefined,
            }}
            name={tableConfig.name}
            sidebarTabs={tabs}
        >
            <SkyNetTable
                moduleName="FreightForwarder"
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default FreightForwarders
